"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Card_1 = __importDefault(require("../Card"));
var Column_1 = __importDefault(require("../Column"));
var Row_1 = __importDefault(require("../Row"));
var renderer_1 = require("@react-pdf/renderer");
var calculations_1 = require("../../utils/calculations");
var math = __importStar(require("mathjs"));
var EdibleCalloutsSection = function (_a) {
    var cannabinoidsPanelResult = _a.cannabinoidsPanelResult, moistureContentPercentage = _a.moistureContentPercentage, density = _a.density, parameters = _a.parameters, rest = __rest(_a, ["cannabinoidsPanelResult", "moistureContentPercentage", "density", "parameters"]);
    var totalTHC = calculations_1.deriveTotalTHC(cannabinoidsPanelResult, moistureContentPercentage, density, parameters);
    var totalCBD = calculations_1.deriveTotalCBD(cannabinoidsPanelResult, moistureContentPercentage, density, parameters);
    var totalCannabinoids = calculations_1.deriveTotalCannabinoids(cannabinoidsPanelResult, moistureContentPercentage, density, parameters);
    return (React.createElement(Row_1.default, null,
        React.createElement(Column_1.default, { style: { margin: 2.15 } },
            React.createElement(EdibleStatsCard, __assign({ title: "Total THC", titleColor: "#9ACA7C", componentPpm: typeof totalTHC === "number" ? totalTHC : 0, valueOverride: typeof totalTHC === "string" ? totalTHC : undefined }, rest))),
        React.createElement(Column_1.default, { style: { margin: 2.15 } },
            React.createElement(EdibleStatsCard, __assign({ title: "Total CBD", titleColor: "#AD84B5", componentPpm: typeof totalCBD === "number" ? totalCBD : 0, valueOverride: typeof totalCBD === "string" ? totalCBD : undefined }, rest))),
        React.createElement(Column_1.default, { style: { margin: 2.15 } },
            React.createElement(EdibleStatsCard, __assign({ title: "Total Cannabinoids", titleFontSize: 12, titleLineHeight: 0.85, componentPpm: typeof totalCannabinoids === "number" ? totalCannabinoids : 0, valueOverride: typeof totalCannabinoids === "string"
                    ? totalCannabinoids
                    : undefined }, rest)))));
};
exports.default = EdibleCalloutsSection;
var EdibleStatsCard = function (_a) {
    var title = _a.title, _b = _a.titleFontSize, titleFontSize = _b === void 0 ? 16 : _b, titleColor = _a.titleColor, titleLineHeight = _a.titleLineHeight, componentPpm = _a.componentPpm, valueOverride = _a.valueOverride, amountPerServing = _a.amountPerServing, amountPerPackage = _a.amountPerPackage;
    return (React.createElement(Card_1.default, { style: {
            width: 110,
            textAlign: "center",
        } },
        React.createElement(renderer_1.Text, { style: {
                fontFamily: "Quicksand",
                fontWeight: 700,
                color: titleColor,
                fontSize: titleFontSize,
                lineHeight: titleLineHeight,
            } }, title),
        React.createElement(renderer_1.View, { style: {
                width: "100%",
                borderBottom: 1,
                borderColor: "#e1e1e1",
                marginVertical: 8,
            } }),
        React.createElement(renderer_1.Text, { style: {
                fontFamily: "Quicksand",
                fontWeight: 700,
                fontSize: 12,
            } }, (function () {
            var _a;
            if (valueOverride)
                return valueOverride;
            if (componentPpm <= 0)
                return "ND";
            if (!(amountPerServing === null || amountPerServing === void 0 ? void 0 : amountPerServing.value))
                return "N/A";
            return math
                .unit(componentPpm * ((_a = amountPerServing.value) !== null && _a !== void 0 ? _a : 0), "ug")
                .to("mg")
                .format({ notation: "fixed", precision: 2 })
                .toString();
        })()),
        React.createElement(renderer_1.Text, { style: {
                fontFamily: "Quicksand",
                fontSize: 10,
            } }, "per serving"),
        React.createElement(renderer_1.View, { style: {
                width: "100%",
                marginVertical: 8,
            } }),
        React.createElement(renderer_1.Text, { style: {
                fontFamily: "Quicksand",
                fontWeight: 700,
                fontSize: 12,
            } }, (function () {
            var _a;
            if (valueOverride)
                return valueOverride;
            if (componentPpm <= 0)
                return "ND";
            if (!(amountPerPackage === null || amountPerPackage === void 0 ? void 0 : amountPerPackage.value))
                return "N/A";
            return math
                .unit(componentPpm * ((_a = amountPerPackage.value) !== null && _a !== void 0 ? _a : 0), "ug")
                .to("mg")
                .format({ notation: "fixed", precision: 2 })
                .toString();
        })()),
        React.createElement(renderer_1.Text, { style: {
                fontFamily: "Quicksand",
                fontSize: 10,
            } }, "per package")));
};
//# sourceMappingURL=index.js.map